export default __webpack_public_path__ + "static/media/finger_positions_DFJK.2ee917b2.jpeg";